type ProfilePictureResponse = {
  profile_picture_icon_url?: string | null;
  profilePictureIconUrl?: string | null;
  profile_picture_icon_url_fullpath?: string | null;
  profilePictureIconUrlFullpath?: string | null;
  profile_pic_file_ref?: string | null;
  profilePicFileRef?: string | null;
};

export function buildProfilePicPayloadFields(input: {
  profilePicFileChanged?: boolean;
  profilePicFileRef?: string | null;
  existingProfilePicRef?: string | null;
}): {
  profile_pic_file_changed: boolean;
  profile_pic_file_ref: string | null;
} {
  const profileChanged = Boolean(input.profilePicFileChanged);
  if (profileChanged) {
    const profileRef = input.profilePicFileRef?.trim() ? input.profilePicFileRef.trim() : null;
    return { profile_pic_file_changed: profileChanged, profile_pic_file_ref: profileRef };
  }
  const existingRef = (input.profilePicFileRef?.trim() || input.existingProfilePicRef?.trim() || '') || null;
  return { profile_pic_file_changed: profileChanged, profile_pic_file_ref: existingRef };
}

export function extractProfilePictureFields(r: ProfilePictureResponse): {
  profilePictureIconUrl: string;
  profilePictureIconUrlFullpath: string;
} {
  const iconUrl = (
    r.profile_picture_icon_url ??
    r.profilePictureIconUrl ??
    r.profile_pic_file_ref ??
    r.profilePicFileRef ??
    ''
  ).trim();
  const iconFullpath = (r.profile_picture_icon_url_fullpath ?? r.profilePictureIconUrlFullpath ?? '').trim();
  const iconFullpathIsUrl = /^https?:\/\//i.test(iconFullpath);

  return {
    profilePictureIconUrl: iconUrl || (iconFullpath && !iconFullpathIsUrl ? iconFullpath : ''),
    profilePictureIconUrlFullpath: iconFullpathIsUrl ? iconFullpath : '',
  };
}
